import React from 'react';
import { multiDropdownMediumWrapper } from '../../companies/documents/CompanyDocumentStyles';
import MultiSelectDropdown from '../MultiSelectDropdown';
import IDropdownOption from '../../../utils/types/IDropdownOption';

interface IReviewStatusDropdownProps {
  onStatusUpdate: (_event: React.FormEvent<HTMLElement>, items: IDropdownOption[]) => void;
  selectedStatuses: string[];
}

const ReviewStatusDropdown = (props: IReviewStatusDropdownProps): JSX.Element => {
  const { onStatusUpdate, selectedStatuses } = props;

  const reviewStatusOptions: IDropdownOption[] = [
    { key: 'PENDING', text: 'Pending' },
    { key: 'ACCEPTED', text: 'Accepted' },
    { key: 'CHANGESREQUESTED', text: 'Changes Requested' },
  ];

  return (
    <MultiSelectDropdown
      label="Status"
      className={multiDropdownMediumWrapper}
      onChange={onStatusUpdate}
      selectedKeys={selectedStatuses}
      placeholder="Select an option"
      options={reviewStatusOptions}
    />
  );
};

export default ReviewStatusDropdown;
